import { useCustomTheme } from '@/hooks/useCustomTheme';

interface DiagramSliceProps {
  d: string;
  color: 'info' | 'success' | 'warning';
}

export const DiagramSlice = ({ d, color }: DiagramSliceProps) => {
  const { palette } = useCustomTheme();

  return <path d={d} fill={palette[color].main} opacity={0.8} />;
};
